import axios from "axios";
import { dispatchtoast, removeLocalStorageItem, showError } from "../../Utils";

// const cookies = new Cookies();
// const jwtToken = cookies.get("jwt_token");
// export const APIURL = "http://192.168.1.111/b2b_dmtpay/";
// export const APIURL = "https://b2b-admin.ezulix.co/";
export const APIURL = "https://hachikinpay.com/";

const ApiService = axios.create({
  // withCredentials: true,
  baseURL: APIURL,
});

// Add a request interceptor
ApiService.interceptors.request.use((config) => {
  // Add the JWT token to the request headers
  // if (jwtToken) {
  //   config.headers['Authorization'] = `jwt_token=${jwtToken}`;
  // }
  // Add other headers if needed
  // config.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return config;
});
// Add a response interceptor
ApiService.interceptors.response.use(
  (response) => {
    if (response.data.status) {
      return response.data;
    } else if (response.data.formErrors) {
      showError(response.data.formErrors);
    } else if (response.data.validationError) {
      showError(response.data.validationError);
    } else {
      dispatchtoast(response.data.message ?? response.data.error, true);
    }
    return response.data;
  },
  (error) => {
    // Handle errors if needed
    const { status } = error?.response;
    if (status === 401) {
      dispatchtoast(
        error?.response.data.message ?? error?.response.data.msg,
        true,
      );
      removeLocalStorageItem("isLoggedIn");
      removeLocalStorageItem("accessToken");
      window.location.href = "/";
    }
    if (status && status >= 400 && status < 500) {
      if (error.response.data.formErrors) {
        showError(error.response.data.formErrors);
      } else if (error.response.data.validationError) {
        showError(error.response.data.validationError);
      } else {
        dispatchtoast(
          error?.response.data.message ?? error?.response.data.error,
          true,
        );
      }
    } else if (status && status >= 500) {
      dispatchtoast(
        error?.response.data.message ?? error?.response.data.msg,
        true,
      );
    }
    return Promise.reject(error);
  },
);

export default ApiService;
